import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import {
  Menu as BurgerIcon,
  Notifications as NotificationIcon,
  PlayArrow as StartReportingIcon,
  Stop as StopReportingIcon
} from "@mui/icons-material";
import { useReporting } from '../context/ReportingContext';
import { Tooltip } from "@mui/material";
import { TooltipContent, TooltipTitle, TooltipSubtitle } from "../styles/TooltipStyles";
// import Logo from '../assets/logo.svg';

const NavbarSection = styled.div`
  ${'' /* width: 100%; */}
  height: 70px;
  padding: 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const NavbarSubSection = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const NavbarActionSection = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const StyledBurgerIcon = styled(BurgerIcon)`
  cursor: pointer;
  color: #52525b;
`;

const StyledLogoIcon = styled.div`
  margin-left: 0.8rem;
  font-size: 24px;
  font-weight: bold;
  color: #4461f2;
`;

const StyledRegularButton = styled.button`
  height: 42px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  background: linear-gradient(105.71deg, #4461f2 39.02%, #5120f3 100%);
  border-radius: 25px;
  padding: 9px 25px;
  cursor: pointer;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledSelectedButton = styled.button`
  height: 42px;
  color: #4461f2;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  padding: 9px 25px;
  border-bottom: solid 1px #4461f2;
  cursor: pointer;
  background: none;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledSpan = styled.span`
  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #52525b;
`;

const StyledNotificationIcon = styled(NotificationIcon)`
  color: #52525b;
  cursor: pointer;
`;

const Navbar = ({
  isSidebarOpen,
  setIsSidebarOpen,
  title,
  isRadiologist = true,
  accountStatus = "verified"
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isReporting, setIsReporting } = useReporting();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  // Check if we're on the dashboard with cases page
  const isDashboardWithCases = location.pathname.includes('/dashboard') && location.pathname.includes('/cases');

  const handleReportingClick = () => {
    if (isDashboardWithCases) return; // Prevent action if on dashboard with cases
    setIsReporting(!isReporting);
    setSnackbarMessage(isReporting ? 'Reporting stopped successfully' : 'You are ready to accept orders now!');
    setSnackbarSeverity('success');
    setSnackbarOpen(true);
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  return (
    <NavbarSection>
      <NavbarSubSection>
        <StyledBurgerIcon
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        />
        <StyledLogoIcon><img src="./LOGO.png" alt="logo" /></StyledLogoIcon>
        <StyledSpan>{title}</StyledSpan>
      </NavbarSubSection>
      <NavbarActionSection>
        {isRadiologist && accountStatus === "verified" && (
          <Tooltip
            title={
              <TooltipContent>
                <TooltipTitle>Feature Blocked</TooltipTitle>
                <TooltipSubtitle>Explore this feature in Scheduled Demo</TooltipSubtitle>
              </TooltipContent>
            }
            arrow
            placement="bottom"
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: 'transparent',
                  '& .MuiTooltip-arrow': {
                    color: 'transparent'
                  }
                }
              }
            }}
          >
            {/* <StyledRegularButton 
              onClick={handleReportingClick}
              disabled={isDashboardWithCases}
              style={{ 
                opacity: isDashboardWithCases ? 0.5 : 1,
                cursor: isDashboardWithCases ? 'not-allowed' : 'pointer',
                background: isDashboardWithCases ? 'gray' : 'linear-gradient(105.71deg, #4461f2 39.02%, #5120f3 100%)'
              }}
            >
              {isReporting ? (
                <>
                  <StopReportingIcon /> Stop Reporting
                </>
              ) : (
                <>
                  <StartReportingIcon /> Start Reporting
                </>
              )}
            </StyledRegularButton> */}
          </Tooltip>
        )}
        <Tooltip
          title={
            <TooltipContent>
              <TooltipTitle>Feature Blocked</TooltipTitle>
              <TooltipSubtitle>Explore this feature in Scheduled Demo</TooltipSubtitle>
            </TooltipContent>
          }
          arrow
          placement="bottom"
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: 'transparent',
                '& .MuiTooltip-arrow': {
                  color: 'transparent'
                }
              }
            }
          }}
        >
          <StyledNotificationIcon />
        </Tooltip>
      </NavbarActionSection>
    </NavbarSection>
  );
};

export default Navbar; 